import { Container, Text, Title } from '@mantine/core';
import { Json } from '../../types';
import { Button } from '../Button/Button';
import { Dots } from './DottedBanner.components';
import classes from './DottedBanner.module.css';
import { Wrapper } from './DottedBanner.style';

export type DottedBannerProps = {
  content: Json;
};

export function DottedBanner(props: DottedBannerProps) {
  const { content } = props;
  const { title, description, ctaText, ctaUrl } = content;

  return (
    <Wrapper className='DottedBanner-wrapper' data-testid='DottedBanner-wrapper'>
      <Container className={classes.wrapper} size={1400}>
        <Dots className={classes.dots} style={{ left: 0, top: 0 }} />
        <Dots className={classes.dots} style={{ left: 60, top: 0 }} />
        <Dots className={classes.dots} style={{ left: 0, top: 140 }} />
        <Dots className={classes.dots} style={{ right: 0, top: 60 }} />

        <div className={classes.inner}>
          <Title className={classes.title}>{title}</Title>

          <Container p={0} size={600}>
            <Text size='lg' c='dimmed' className={classes.description}>
              {description}
            </Text>
          </Container>

          <div className={classes.controls}>
            <Button
              className={classes.control}
              size='lg'
              variant='default'
              component='a'
              href={ctaUrl}
              target='_blank'
              radius='xl'
            >
              {ctaText}
            </Button>
          </div>
        </div>
      </Container>
    </Wrapper>
  );
}

export default DottedBanner;
